import React from 'react';
import Alert from 'react-bootstrap/Alert';

/**
 * Inline summary after catalog or custom quote-request emails are sent.
 *
 * @param {{ result?: { corporate_demand_ref?: string, suppliers?: Array } }} props
 */
const CatalogQuoteEmailResultSummary = ({ result }) => {
  if (!result?.suppliers?.length) return null;
  return (
    <Alert variant="success" className="mb-3">
      {result.corporate_demand_ref ? (
        <p className="mb-2">
          <strong>Corporate demand ref:</strong> {result.corporate_demand_ref}
        </p>
      ) : null}
      <ul className="mb-0 ps-3">
        {result.suppliers.map((s, idx) => (
          <li key={s.supplier_id ?? s.supplier_name ?? idx}>
            {s.supplier_name || 'Supplier'}
            {s.item_count != null ? ` — ${s.item_count} item(s)` : ''}
            {' — '}
            email {s.emailSent ? 'sent' : 'not sent'}
          </li>
        ))}
      </ul>
    </Alert>
  );
};

export default CatalogQuoteEmailResultSummary;
